import Backbone from "backbone";
import inject from "scripts/ioc/inject";
import BaseMediaSalvattoreTileView from "scripts/views/baseMediaSalvattoreTileView";

import templateAudioSalvattoreTile from "templates/audioSalvattoreTile.hbs";

const chan = Backbone.Radio.channel;

class AudioSalvattoreTileView extends BaseMediaSalvattoreTileView {
  constructor(options, securityService = inject("securityService")) {
    super(options, securityService);
  }

  get template() {
    return templateAudioSalvattoreTile;
  }

  onClickViewer() {
    if (this.model.has("referringParent")) {
      this.saveReferringParent();
    }

    chan("display").request("playAudio", this.model);
    chan("tracking").trigger("viewer:click", this.model);
    return false;
  }
}

export default AudioSalvattoreTileView;
